import React from 'react';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';
import './styles.css';
import RenderingStyling from '../../../lib/RenderingStyling';

const ResponsiveGrid = ({ rendering }) => {
  return (
    <div className="responsive-grid" {...RenderingStyling(rendering.name)}>
      <div className="c-container">
        <Placeholder
          name="responsive-grid"
          rendering={rendering}
          render={(components, placeholderData, props) => {
            const rowClass = components?.length > 3 ? 'c-row four' : 'c-row';
            if (!Array.isArray(components) || components.length === 0) {
              return <div className={rowClass}></div>;
            }
            return (
              <div className={rowClass}>
                {components.map((component) => {
                  if (component?.type === 'code') {
                    return <>{component}</>;
                  }
                  return <div className="c-col">{component}</div>;
                })}
              </div>
            );
          }}
        />
      </div>
    </div>
  );
};

export default ResponsiveGrid;
